const store = {
    namespaced: true,
    state() {
        return {
            topSliders: [],
            mainSliders: [],
            bottomSliders: [],
            isPreloaderSliders: false
        }
    },
    getters: {
        getTopSliders(state) {
            return state.topSliders;
        },
        getMainSliders(state) {
            return state.mainSliders;
        },
        getBottomSliders(state) {
            return state.bottomSliders;
        }
    },
    mutations: {
        setTopSliders(state, sliders) {
            state.topSliders = sliders;
        },
        setMainSliders(state, sliders) {
            state.mainSliders = sliders;
        },
        setBottomSliders(state, sliders) {
            state.bottomSliders = sliders;
        }
    },
    actions: {
        async fetchSliders({ commit }) {
            try {
                const sliders = await this.$axios.$get('base/slides_banner');
                const topSliders = [];
                const mainSliders = [];
                const bottomSliders = [];
                for (const slider of sliders) {
                    if (slider.show_on === 'top') {
                        topSliders.push(slider);
                    }
                    if (slider.show_on === 'main') {
                        mainSliders.push(slider);
                    }
                    if (slider.show_on === 'bottom') {
                        bottomSliders.push(slider);
                    }
                }
                commit('setTopSliders', topSliders);
                commit('setMainSliders', mainSliders);
                commit('setBottomSliders', bottomSliders);
            } catch (e) {
                console.error(e);
            }
        }
    }
}

export default store